export default __webpack_public_path__ + "static/mobileapp-927370f84b9c66894f1497586686d2c9.webp";